import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/inventario/calcularCosto';
import SeleccionarPeriodo from './SeleccionarPeriodo';


const ms2p = (state) => {
  return {
    ...state.costo,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(SeleccionarPeriodo);
